import React from "react";
import "./CharacterizationRadio.scss"
import { MdCheckCircle } from "react-icons/md";
import TextComponent from "app_components/commons/TextComponent/TextComponent";

interface ICharacterizationRadioProps {
  onClick: () => void
  checked: boolean
  label: any
}

function CharacterizationRadio(props: ICharacterizationRadioProps) {

    return(
      <div className="characterization-radio--container" >
        {props.checked===true ?
          <MdCheckCircle onClick={props.onClick} size={25} color="#0085CA"/> :
          <div onClick={props.onClick} className="circle-gray"></div>
        }
        <TextComponent onClick={props.onClick} className="characterization-radio--label" color="rgb(120, 114, 114)" >{props.label}</TextComponent>
      </div>
    )
}


export default CharacterizationRadio
